// src/config/payments.js

export const PAYMENT_PROVIDERS = {
    CLOUD_PAYMENTS: 'cloud_payments',
    MOCK: 'mock'
};

export const PAYMENT_METHODS = {
    CARD: 'card',
    CASH: 'cash',
    SBP: 'sbp'
};

export const PAYMENT_STATUS = {
    PENDING: 'pending',
    PROCESSING: 'processing',
    SUCCESS: 'success',
    FAILED: 'failed',
    CANCELLED: 'cancelled'
};

export const PAYMENT_SCENARIOS = {
    SUCCESS: 'SUCCESS',
    FAILED: 'FAILED',
    THREEDS: 'THREEDS'
};

export const DEFAULT_PAYMENT_CONFIG = {
    provider: PAYMENT_PROVIDERS.CLOUD_PAYMENTS,
    methods: [PAYMENT_METHODS.CARD, PAYMENT_METHODS.CASH],
    testMode: false,
    currencies: ['RUB'],
    credentials: null,
    options: {
        skin: 'modern',
        language: 'ru-RU'
    },
    isActive: true
};